/** Formátování převzaté z prototypu. Částky přichází z API jako řetězce "1234.50". */

let NF = new Intl.NumberFormat('cs-CZ', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
let NF0 = new Intl.NumberFormat('cs-CZ', { maximumFractionDigits: 0 });
let LOCALE: 'cs' | 'en' = 'cs';

/** Formát čísel a dat podle jazyka aplikace (fáze 16, dluh z fáze 14); volá I18nProvider. */
export function setFormatLocale(locale: 'cs' | 'en'): void {
  LOCALE = locale;
  const tag = locale === 'en' ? 'en-GB' : 'cs-CZ';
  NF = new Intl.NumberFormat(tag, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  NF0 = new Intl.NumberFormat(tag, { maximumFractionDigits: 0 });
}

const toNumber = (v: number | string): number => (typeof v === 'number' ? v : Number(v) || 0);

export const czk = (v: number | string): string => `${NF.format(toNumber(v))} Kč`;
export const czk0 = (v: number | string): string => `${NF0.format(toNumber(v))} Kč`;

const SYMBOL: Record<string, string> = {
  CZK: 'Kč',
  EUR: '€',
  USD: '$',
  GBP: '£',
  PLN: 'zł',
  HUF: 'Ft',
  CHF: 'CHF',
  AED: 'AED',
};
export const CURRENCIES = ['CZK', 'EUR', 'USD', 'GBP', 'PLN', 'HUF', 'CHF', 'AED'] as const;
export const currencySymbol = (c: string): string => SYMBOL[c] ?? c;
/** Částka v měně dokladu: „1 210,00 €", „1 210,00 AED"; CZK zůstává „Kč". */
export const money = (v: number | string, currency = 'CZK'): string =>
  `${NF.format(toNumber(v))} ${currencySymbol(currency)}`;
export const money0 = (v: number | string, currency = 'CZK'): string =>
  `${NF0.format(toNumber(v))} ${currencySymbol(currency)}`;

/** "2026-09-05" → "5. 9. 2026" */
export function dt(iso: string | null | undefined): string {
  if (!iso) return '';
  const [y, m, d] = iso.slice(0, 10).split('-');
  if (LOCALE === 'en') return `${Number(d)}/${Number(m)}/${y}`;
  return `${Number(d)}. ${Number(m)}. ${y}`;
}

/** "2026-09-05" → "5. 9." */
export function dts(iso: string): string {
  const [, m, d] = iso.slice(0, 10).split('-');
  if (LOCALE === 'en') return `${Number(d)}/${Number(m)}`;
  return `${Number(d)}. ${Number(m)}.`;
}

export function addDays(iso: string, n: number): string {
  const d = new Date(`${iso}T12:00:00`);
  d.setDate(d.getDate() + n);
  return d.toISOString().slice(0, 10);
}

export function daysBetween(a: string, b: string): number {
  return Math.round((new Date(b).getTime() - new Date(a).getTime()) / 86_400_000);
}

export function todayIso(): string {
  const d = new Date();
  const local = new Date(d.getTime() - d.getTimezoneOffset() * 60_000);
  return local.toISOString().slice(0, 10);
}

export function plural(n: number, forms: readonly [string, string, string]): string {
  if (n === 1) return forms[0];
  if (n >= 2 && n <= 4) return forms[1];
  return forms[2];
}

/** Uživatelský vstup s čárkou a mezerami → číslo; nevalidní = 0. */
export function num(v: string | number): number {
  const n = Number.parseFloat(String(v).replace(/\s/g, '').replace(',', '.'));
  return Number.isFinite(n) ? n : 0;
}

export const cap = (s: string): string => s.charAt(0).toUpperCase() + s.slice(1);

export const MONTHS = [
  'led',
  'úno',
  'bře',
  'dub',
  'kvě',
  'čvn',
  'čvc',
  'srp',
  'zář',
  'říj',
  'lis',
  'pro',
];
export const MONTHS_L = [
  'leden',
  'únor',
  'březen',
  'duben',
  'květen',
  'červen',
  'červenec',
  'srpen',
  'září',
  'říjen',
  'listopad',
  'prosinec',
];
/** Měsíc v 6. pádě pro „v říjnu“, „v září“. */
export const MONTHS_IN = [
  'lednu',
  'únoru',
  'březnu',
  'dubnu',
  'květnu',
  'červnu',
  'červenci',
  'srpnu',
  'září',
  'říjnu',
  'listopadu',
  'prosinci',
];

/** Zaokrouhlení na haléře (půl nahoru), bez chyby binárního floatu u typických částek. */
export const round2 = (n: number): number => Math.round((n + Number.EPSILON) * 100) / 100;
